var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons8-facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-facebook",
    transform: "translate(0.000309, -0.000397)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66569078,0.00539652967 C4.61969078,0.17039653 0.373690778,4.25139653 0.0246907778,9.28839653 C-0.344309222,14.6173965 3.46669078,19.1203965 8.50569078,19.8773965 L8.50569078,12.6503965 L6.89169078,12.6503965 C6.16569078,12.6503965 5.57769078,12.0623965 5.57769078,11.3363965 L5.57769078,11.3363965 C5.57769078,10.6103965 6.16569078,10.0223965 6.89169078,10.0223965 L8.50469078,10.0223965 L8.50469078,8.27339653 C8.50469078,5.37739653 9.91569078,4.10639653 12.3226908,4.10639653 C12.6796908,4.10639653 12.9846908,4.11439653 13.2436908,4.12739653 C13.8796908,4.15839653 14.3726908,4.68839653 14.3726908,5.32539653 L14.3726908,5.32539653 C14.3726908,5.98839653 13.8356908,6.52539653 13.1726908,6.52539653 L12.7306908,6.52539653 C11.7086908,6.52539653 11.3516908,7.49439653 11.3516908,8.58639653 L11.3516908,10.0233965 L13.2216908,10.0233965 C13.8126908,10.0233965 14.2646908,10.5503965 14.1746908,11.1343965 L14.0666908,11.8353965 C13.9936908,12.3053965 13.5896908,12.6523965 13.1136908,12.6523965 L11.3516908,12.6523965 L11.3516908,19.8993965 C16.2346908,19.2363965 19.9996908,15.0623965 19.9996908,10.0003965 C19.9996908,4.36639653 15.3406908,-0.17860347 9.66569078,0.00539652967 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhite);
export default __webpack_public_path__ + "static/media/facebook-white.6923d7fe7fd22cd947740cbf481abf9d.svg";
export { ForwardRef as ReactComponent };